import ServiceApi from "../services/service.api";

// const baseServiceUrl = `/auth`;
const baseServiceUrl = `/api/v1/Account`;

const ApiAccount = {
  forgotPasswordRequest: (input) => {
    const url = `${baseServiceUrl}/forgot-password`;
    return ServiceApi.post(url, input);
  },

  confirmEmail: (input) => {
    const url = `${baseServiceUrl}/confirm-email`;
    return ServiceApi.put(url, input);
  },

  forgotPasswordReset: (input) => {
    const url = `${baseServiceUrl}/reset-password`;
    return ServiceApi.post(url, input);
  },

  setPassword: (input) => {
    const url = `${baseServiceUrl}/set-password`;
    return ServiceApi.post(url, input);
  },
  createAccount: (params) => {
    
    const url = `${baseServiceUrl}/createAccount`;
    

    return ServiceApi.post(url,params);
  },
  getAllAccountForUserId: (params) => {
      
      const url = `${baseServiceUrl}/getAllAccountForUserId`;
      
  
      return ServiceApi.get(url,params);
    },
};

export default ApiAccount;
